var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14713 10.6722C1.33603 10.8607 1.58354 10.9549 1.8311 10.9549C2.07866 10.9549 2.32623 10.8607 2.51508 10.6722L6.07097 7.12548L9.62691 10.6722C9.81576 10.8607 10.0633 10.9549 10.3109 10.9549C10.5584 10.9549 10.806 10.8607 10.9949 10.6722C11.3726 10.2956 11.3726 9.68464 10.9949 9.30785L7.43888 5.76109L10.9948 2.21428C11.3725 1.8375 11.3725 1.22659 10.9948 0.849848C10.6171 0.473065 10.0046 0.473065 9.62687 0.849848L6.07093 4.39665L2.51503 0.849848C2.13728 0.473065 1.52479 0.473065 1.14708 0.849848C0.769331 1.22663 0.769331 1.8375 1.14708 2.21428L4.70302 5.76109L1.14708 9.30785C0.769376 9.68464 0.769376 10.2956 1.14713 10.6722Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fc9119eac05065f684cdd11490a7ca53.svg";
export { ForwardRef as ReactComponent };